import PropTypes from 'prop-types'
import React from 'react'

import ReserveBonus from 'components/ReserveBonus/ReserveBonus.jsx'
import Reserve from 'components/Reserve/Reserve.jsx'

import { MAX_BUILDING_LEVEL } from 'constants'

import styles from './ReserveInfoBar.scss'

const ReserveInfoBar = (props) => {
    const { type: reserveType } = props.reserveInfo
    const nextLevel = (props.level < MAX_BUILDING_LEVEL ? props.level + 1 : props.level)

    const bonusType = props.viewType ? props.viewType : 'default'

    return (
        <div className={styles.base}>
            <div className={styles.button}>
                <Reserve
                    type={reserveType}
                    level={props.highlighted ? nextLevel : props.level}
                    reserves={props.reserves}
                    highlighted={props.highlighted}
                    playSound={props.playSound || null}
                />
            </div>
            <div className={styles.content}>
                <ReserveBonus
                    reserveInfo={props.reserveInfo}
                    level={props.level}
                    nextLevel={nextLevel}
                    isNextLevelHighlighted={props.highlighted}
                    layoutType={bonusType}
                />
            </div>
        </div>
    )
}

ReserveInfoBar.propTypes = {
    reserveInfo: PropTypes.object.isRequired,
    level: PropTypes.number.isRequired,
    reserves: PropTypes.arrayOf(PropTypes.object).isRequired,
    highlighted: PropTypes.bool.isRequired,
    viewType: PropTypes.oneOf(['default', 'tooltip', 'toolbar']),
    playSound: PropTypes.func,
}

export default ReserveInfoBar



// WEBPACK FOOTER //
// ./components/ReserveInfoBar/ReserveInfoBar.jsx